import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings } from '@progress/kendo-react-data-tools'
import { TransactionFilterKey } from 'api/Transaction/Types/Transaction'
import { TransactionType } from 'api/Wallet/Types/TransactionTypeDto'
import { useAppSelector } from 'store'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { getIBTransactionsFilters } from './getIBTransactionsFilters'
import { SelectFilter } from './SelectFilter'

const TransactionTypeFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  const transactionTypes = useAppSelector((state) => state.transactions.types)

  const data = transactionTypes.length
    ? transactionTypes
        .filter(
          (x) =>
            x.id === TransactionType.IBCommission ||
            x.id === TransactionType.MIBCommission ||
            x.id === TransactionType.IBMultiTier
        )
        .map((x) => ({ id: x.id, label: x.name, value: x.id }))
    : []

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const getIBCommissionsFilters = (): FieldSettings[] => [
  {
    name: TransactionFilterKey.type,
    label: 'Type',
    filter: TransactionTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  ...getIBTransactionsFilters(),
]
